import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function MePage() {
  const { userProfile } = useAuth();
  const loginId = String(userProfile?.email || '').split('@')[0] || '-';
  const contact = userProfile?.contact || '';
  const linkedFarmerId = userProfile?.linkedFarmerId || '';
  const createReportUrl = linkedFarmerId
    ? `/admin/reports?editor=farmer&mode=create&farmerId=${encodeURIComponent(linkedFarmerId)}`
    : '/admin/reports?editor=farmer&mode=create';
  const editReportUrl = linkedFarmerId
    ? `/admin/reports?editor=farmer&mode=edit&farmerId=${encodeURIComponent(linkedFarmerId)}`
    : '/admin/reports?editor=farmer&mode=edit';

  return (
    <>
      <Helmet><title>Drs.Farm | 農家さんメニュー</title></Helmet>
      <h1>農家さんメニュー</h1>
      <p className="hint">必要な操作を選択してください。</p>
      <section className="panel">
        <h2>アカウント情報</h2>
        <p className="directory-meta">ID: {loginId}</p>
        <p className="directory-meta">連絡先: {contact || '未設定'}</p>
      </section>
      <section className="panel">
        <div className="admin-grid">
          <article className="panel admin-menu-mini-panel">
            <div>
              <strong>近況報告</strong>
              <p>新しい近況報告を作成します。</p>
            </div>
            <Link className="btn btn-primary" to={createReportUrl}>開く</Link>
          </article>
          <article className="panel admin-menu-mini-panel">
            <div>
              <strong>近況報告の修正</strong>
              <p>作成済みの近況報告を編集します。</p>
            </div>
            <Link className="btn btn-secondary" to={editReportUrl}>開く</Link>
          </article>
          <article className="panel admin-menu-mini-panel">
            <div>
              <strong>近況報告の承認ステータス</strong>
              <p>申請中・承認済み・差し戻しを確認します。</p>
            </div>
            <Link className="btn btn-secondary" to="/me/reports-status">開く</Link>
          </article>
          <article className="panel admin-menu-mini-panel">
            <div>
              <strong>設定</strong>
              <p>パスワードなどの設定を変更します。</p>
            </div>
            <Link className="btn btn-secondary" to="/settings">開く</Link>
          </article>
        </div>
      </section>
    </>
  );
}
